import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';

interface ExcelFilesContext {
    isLoading: boolean
    isImporting: boolean
    isImported: boolean
    excelImport: IExcelFiles

    doImport: () => Promise<void>
}

export let excelImportContext = React.createContext({} as ExcelFilesContext);

interface IExcelFiles {
    countryCode: string
    status: IStatus
}

interface IStatus {
    errors: string[]
    info: string[]
    warnings: string[]
    fileName: string
    isFileValid: boolean
    dealersToAdd: number
    dealersToUpdate: number
    hasErrors: boolean
    validColumns: string
    invalidColumns: string
}

let { Provider } = excelImportContext;

let ExcelFilesProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    let { id } = useParams<{ id: string }>();

    let [isLoading, setLoading] = useState(true);
    let [excelImport, setExcelImport] = useState({} as IExcelFiles);

    let [isImporting, setImporting] = useState(false);
    let [isImported, setImported] = useState(false);

    useEffect(() => {
        getImportRequest();
    }, [id]);

    useEffect(() => {
        if (isImporting === true)
            getExcelImportStatus();
    }, [isImporting]);

    let getImportRequest = async () => {
        try {
            setLoading(true);
            setImported(false);
            setImporting(false);

            let res = await axios.get('/api/ExcelImport/GetExcelImportRequest', { params: { requestId: id } });
            setExcelImport(res.data.item);

        } catch (err) { }
        finally {
            setLoading(false);
        }
    }

    let doImport = async () => {
        if (window.confirm("Do you really want to import this file?")) {
            try {
                setImporting(true);

                let request = {
                    id: id
                }

                await axios.post('/api/ExcelImport/StartExcelImport', request);
                setImporting(true);

            } catch (err) {
            }
        }
    }

    let getExcelImportStatus = async () => {
        try {
            let res = await axios.get('/api/ExcelImport/GetExcelRequestStatus', { params: { requestId: id } });

            if (res.data === false)
                window.setTimeout(getExcelImportStatus, 900);
            else {
                setImported(true);
                setImporting(false);
            }
        } catch (err) {
            setImporting(false);
        }
    }

    return (
        <Provider
            value={{
                isLoading,
                isImporting,
                isImported,
                excelImport,

                doImport
            }}
        >
            {children}
        </Provider>
    )
}

export default ExcelFilesProvider;